import { Appointment } from 'types/appointments';

export type StaffOnlyStatus =
  | 'ONLINE_AND_STAFF_AVAILABLE'
  | 'ONLINE_AVAILABLE'
  | 'STAFF_ONLY_AVAILABLE'
  | 'NO_FREE_APPOINTMENTS';

export const ONLINE_AND_STAFF_AVAILABLE: StaffOnlyStatus =
  'ONLINE_AND_STAFF_AVAILABLE';
export const ONLINE_AVAILABLE: StaffOnlyStatus = 'ONLINE_AVAILABLE';
export const STAFF_ONLY_AVAILABLE: StaffOnlyStatus = 'STAFF_ONLY_AVAILABLE';
export const NO_FREE_APPOINTMENTS: StaffOnlyStatus = 'NO_FREE_APPOINTMENTS';

export const useAppointmentOnlineStaffOnlySplit = ({
  appointments,
}: {
  appointments: Appointment[];
}): {
  freeOnlineAppointments: Appointment[];
  freeStaffAppointments: Appointment[];
  onlineSplitStatus: StaffOnlyStatus;
} => {
  const freeOnlineAppointments = appointments.filter((a) => !a.staff_only);
  const freeStaffAppointments = appointments.filter((a) => a.staff_only);
  if (freeOnlineAppointments.length > 0 && freeStaffAppointments.length > 0) {
    return {
      onlineSplitStatus: ONLINE_AND_STAFF_AVAILABLE,
      freeOnlineAppointments,
      freeStaffAppointments,
    };
  } else if (freeOnlineAppointments.length > 0) {
    return {
      onlineSplitStatus: ONLINE_AVAILABLE,
      freeOnlineAppointments,
      freeStaffAppointments: [],
    };
  } else if (freeStaffAppointments.length > 0) {
    return {
      onlineSplitStatus: STAFF_ONLY_AVAILABLE,
      freeOnlineAppointments: [],
      freeStaffAppointments,
    };
  }
  return {
    freeOnlineAppointments: [],
    freeStaffAppointments: [],
    onlineSplitStatus: NO_FREE_APPOINTMENTS,
  };
};
